import { NOTIFICATION_TYPES } from "../data"
import { getNavigateToLink as getNavigateToJobLink } from "./useJobUtils"

const useNotificationUtils = () => {
  const getNavigateToLink = (notification) => {
    switch (notification.type) {
      case NOTIFICATION_TYPES.POST:
        return `/hub/post/${notification?.post?.id || "unknown"}`
      case NOTIFICATION_TYPES.ACTION:
        return `/hub/action/${notification?.action?.id || "unknown"}`
      case NOTIFICATION_TYPES.TRAINING:
        return `/knowledge/training/${notification?.userTraining?.id || "unknown"}`
      case NOTIFICATION_TYPES.ACCREDITATION:
        return "/account/accreditation"
      case NOTIFICATION_TYPES.JOB:
        return getNavigateToJobLink(notification.job)
      default:
    }
  }

  return {
    getNavigateToLink,
  }
}

export { useNotificationUtils }
